import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Nova Microgreens · Fresh & Local</p>
        <h1>Discover the Freshness of Microgreens</h1>
        <p className="lede">
          Elevate your meals with our vibrant, nutrient-rich microgreens, sourced locally in Northern Virginia. Perfect for restaurants, home cooks, and local markets.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_blank">
            Shop Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Fresh from Our Farm</h2>
          <p>
            Our microgreens are harvested daily to ensure peak freshness and flavor, bringing the farm directly to your table.
          </p>
        </article>
        <article>
          <h2>Perfect for Every Dish</h2>
          <p>
            Add a burst of flavor and nutrition to salads, sandwiches, and entrees with our diverse selection of microgreens.
          </p>
        </article>
        <article>
          <h2>Support Local</h2>
          <p>
            By choosing Nova Microgreens, you're supporting local agriculture and enjoying the best produce Northern Virginia has to offer.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;